// update state
const setRoleIdAction = (payload) => {
    return {
        type: "ROLEID",
        payload
    }

}

export default setRoleIdAction;




// WEBPACK FOOTER //
// ./src/actions/setRoleIdAction.js